import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-127">
      <button className="w-full flex items-center justify-between p-5 text-left bg-white hover:bg-gray-50 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-forest/30 focus:ring-inset" onClick={onToggle} aria-expanded={isOpen} data-id="element-128">
        <span className="font-sans font-semibold text-forest-dark text-base pr-4" data-id="element-129">
          {question}
        </span>
        <ChevronDownIcon className={`w-5 h-5 text-forest flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-130" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-131">
        <div className="px-5 pb-5 pt-0" data-id="element-132">
          <p className="font-sans text-gray-600 leading-relaxed text-[15px]" data-id="element-133">
            {answer}
          </p>
        </div>
      </div>
    </div>;
}
export function FAQBlock() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-white py-12 md:py-16 px-5" data-id="element-134">
      <div className="max-w-2xl mx-auto" data-id="element-135">
        {/* Title */}
        <h2 className="font-serif text-forest text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-136">
          Frequently Asked Questions
        </h2>

        {/* FAQ Items */}
        <div className="space-y-3" data-id="element-137">
          <FAQItem question="Is this a physical book?" answer="No. This is an instant digital download (PDF). You get access immediately after purchase on any phone, tablet, or computer." isOpen={openIndex === 0} onToggle={() => handleToggle(0)} data-id="element-138" />

          <FAQItem question="Will this work for my state/climate?" answer="Yes. The guide is built around the official USDA Plant Hardiness Zone Map, which covers all 50 US states. You'll know exactly what to do for YOUR specific zone." isOpen={openIndex === 1} onToggle={() => handleToggle(1)} data-id="element-139" />

          <FAQItem question="I'm not an expert gardener. Is this for me?" answer="Especially for you. This guide was written for everyday homeowners — not botanists. Every checklist is simple, visual, and takes less than 10 minutes to follow." isOpen={openIndex === 2} onToggle={() => handleToggle(2)} data-id="element-140" />

          <FAQItem question="What if it doesn't work for me?" answer="You're covered by our 30-Day Money Back Guarantee. If you're not happy for any reason, email us and we'll refund you immediately." isOpen={openIndex === 3} onToggle={() => handleToggle(3)} data-id="element-141" />

          <FAQItem question="Why is it only $6.37?" answer="We'd rather have 10,000 happy gardeners than 100 expensive customers. Our goal is to get this in as many hands as possible before the next season hits." isOpen={openIndex === 4} onToggle={() => handleToggle(4)} data-id="element-142" />
        </div>
      </div>
    </section>;
}